import type * as React from 'react';
import { StyleSheet, type ViewStyle } from 'react-native';

import { images } from '@gitbook/doc-core';
import type { InlineProps } from '@gitbook/slate-react';

import { DOMView } from '../../DragAndDrop';
import { Image } from '../../Image';

/**
 * Basic renderer for an inline image.
 */
export function BasicInlineImage(props: InlineProps): React.ReactElement {
    const { node } = props;

    const ref = node.data.get('ref');
    const altText = images.getImageAltText(node);
    const { url } = ref;

    return (
        <DOMView editable={false} style={styles.inlineImageWrapper}>
            <Image source={{ uri: url }} style={styles.inlineImage} accessibilityLabel={altText} />
        </DOMView>
    );
}

const styles = StyleSheet.create({
    // @ts-ignore
    inlineImageWrapper: {
        display: 'inline-flex',
        textAlignVertical: 'center',
    } as ViewStyle,
    inlineImage: {
        maxWidth: 300,
    },
});
